<template>
    <div>
        <label class="text-center">{{ label }}</label>
        <div class="d-flex align-items-center gap-6">
            <span @click="handleMinus">
                <i class="text-primary text-3xl fa fa-minus-circle"/>
            </span>
            <input v-model="dataValue" @change="updateValue" type="number" class="border-0 text-center max-w-50px text-xl"/>
            <span @click="handlePlus">
                <i class="text-primary text-3xl fa fa-plus-circle"/>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        value: Number,
    },

    data() {
        return {
            dataValue: 0,
        };
    },

    mounted() {
        if (this.value) {
            this.dataValue = this.value;
        }
    },

    methods: {
        handleMinus() {
            if (this.dataValue > 1) {
                this.dataValue--;
                this.$emit('update:value', this.dataValue);
            }
        },

        handlePlus() {
            this.dataValue++;
            this.$emit('update:value', this.dataValue);
        },

        updateValue() {
            this.$emit('update:value', parseInt(this.dataValue));
        }
    },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>